import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { CURRENCIES, VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import { onChange } from '../../utils/functions'
import Textarea from '../../components/Textarea'
import Button from '../../components/Button'
import { SUPPLIER_PATH, getSupplierById, updateSupplier } from '../../api/supplierApi'
import Spinner from '../../components/Spinner'
import CurrencyPicker from '../../components/currency/CurrencyPicker'

const SupplierEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const [entity, setEntity] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${SUPPLIER_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${SUPPLIER_PATH}`, false)

    useEffect(() => {
        getSupplierById(id).then(res => setEntity(res.data))
    }, [id])

    const onClickSubmit = () => {
        updateSupplier(id, entity)
            .then(res => {
                closeTab()
                toast.success('Tedarikçi güncellendi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Tedarikçi Düzenle</label>
                <Input
                    label='Tedarikçi Kodu'
                    name='code'
                    placeholder='Tedarikçi kodu girin'
                    error={errors.code}
                    value={entity.code}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='Tedarikçi Adı'
                    name='name'
                    placeholder='Tedarikçi adı girin'
                    error={errors.name}
                    value={entity.name}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='Telefon Numarası'
                    name='phone'
                    placeholder='Telefon numarası girin'
                    error={errors.phone}
                    value={entity.phone}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Textarea
                    label='Adres'
                    name='address'
                    placeholder='Adres girin'
                    value={entity.address}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <CurrencyPicker
                    label="Kur"
                    value={entity.currency}
                    onChange={(currency) => setEntity(prevState => ({ ...prevState, currency }))}
                    text={(entity.currency) || 'Kur seçin'}
                    items={CURRENCIES}
                    error={errors.currency}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    value={entity.description}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                {/* <Input
                    label='Borç (Tedarikçiye ödenen miktar)'
                    name='debt'
                    type='number'
                    placeholder='TTedarikçiye ödenen miktar girin...'
                    error={errors.debt}
                    value={(entity.debt)}
                    onChange={e => onChange(e, setEntity, setErrors)}
                    symbol={entity.currency}
                />
                <Input
                    label='Alacak (Tedarikçinin sizden alacağı)'
                    name='credit'
                    type='number'
                    placeholder='TTedarikçinin sizden alacağı miktarı girin...'
                    error={errors.credit}
                    value={entity.credit}
                    onChange={e => onChange(e, setEntity, setErrors)}
                    symbol={entity.currency}
                /> */}
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default SupplierEditPage